<app-header-nav></app-header-nav>
<!-- begin::Body -->
<router-outlet></router-outlet>
<!-- end::Body -->
<app-footer></app-footer>



// WEBPACK FOOTER //
// ./src/app/core/core.component.html